import { CSSTransition } from 'react-transition-group';
import { Advt } from './components/Advt/Advt';
import { Messages } from './components/Messages/Messages';

import { useGetParams } from './hooks/useGetParams';
import { useBroadcast } from './hooks/useBroadcast';

import defaultBackground from './assets/images/bg.png';
import { useMemo } from 'react';

function App() {
  const { isVisible, currentState, showedMessages } = useBroadcast();
  const { bg, speedSlow } = useGetParams();

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${bg === '1' ? defaultBackground : bg}) center/cover no-repeat`
      : `none`;
  }, [bg]);

  return (
    <div
      className="app-wrapper"
      style={{
        background,
        '--speed': `${speedSlow || 2000}ms`,
        '--speedExit': `${(speedSlow || 2000) / 1.5}ms`,
      }}>
      <div className="messagesWrapper">
        <CSSTransition
          in={isVisible && currentState && currentState === 'S1'}
          timeout={500}
          classNames="fade-scale"
          unmountOnExit>
          <Messages messages={showedMessages} speedSlow={speedSlow} />
        </CSSTransition>
      </div>

      <CSSTransition
        in={isVisible}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit>
        <div className="advtWrapper">
          <Advt />
        </div>
      </CSSTransition>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
